<template>

  <div class="container"
    style="display: flex;flex-wrap: wrap;outline: auto;height: 100%;justify-content: center;align-content: flex-start;">
    <!-- <div class="password-alert">
      <p> WEB 界面登陆主机</p>
    </div> -->
    <input type="file" ref="fileInput" style="display: none;" @change="handleFileChange" />
    <div style="width: 100%;height: 100px;color: #fff;padding: 0px 10px; display: flex;align-items: center;">
      <div :style="{ backgroundImage: `url(${require('@/assets/title.png')})` }"
        style="width: 200px;height: 100px;font-size: 30px;font-weight: 700;display: flex;justify-content: center;align-items: center;background-size: 100% 100%;">
        集控平台</div>

      <div class="but" :style="{ backgroundImage: `url(${require('@/assets/but.png')})` }"
        @click="router.push({ name: 'RoomView' });"
        style="width: 124px;height: 50px;font-size: 17px;font-weight: 400;display: flex;justify-content: center;align-items: center;background-size: 100% 100%;margin-left: 25px;cursor: pointer;">
        返回</div>

      <div class="but" :style="{ backgroundImage: `url(${require('@/assets/but.png')})` }" @click="triggerFileInput"
        style="width: 124px;height: 50px;font-size: 17px;font-weight: 400;display: flex;justify-content: center;align-items: center;background-size: 100% 100%;margin-left: 25px;cursor: pointer;">
        导入</div>

      <div class="but" :style="{ backgroundImage: `url(${require('@/assets/but.png')})` }" @click="downloadJson"
        style="width: 124px;height: 50px;font-size: 17px;font-weight: 400;display: flex;justify-content: center;align-items: center;background-size: 100% 100%;margin-left: 25px;cursor: pointer;">
        导出</div>

      <div class="but" :style="{ backgroundImage: `url(${require('@/assets/but.png')})` }"
        style="width: 124px;height: 50px;font-size: 17px;font-weight: 400;display: flex;justify-content: center;align-items: center;background-size: 100% 100%;margin-left: 25px;cursor: pointer;">
        一键恢复出厂</div>
    </div>
    <div style="width: 100%;">
      <div style="width: 100%;height: 100px;display: flex;justify-content: space-around;">
        <div
          style="width: 8%;color: #fff;height: 90px;display: flex;align-items: center;justify-content: center;font-size: 17px;font-weight: 400;float: left;">

        </div>
        <div
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;color: #fff;font-size: 17px;font-weight: 400;justify-content: center;">
          环噪等级
        </div>

        <div
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;color: #fff;font-size: 17px;font-weight: 400;text-align: center;justify-content: center;">
          智能调校
        </div>
        <div
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;color: #fff;font-size: 17px;font-weight: 400;text-align: center;justify-content: center;">
          <div
            style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;color: #fff;font-size: 17px;font-weight: 400;text-align: center;justify-content: center;">
            MicVol
          </div>
        </div>
        <div
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;color: #fff;font-size: 17px;font-weight: 400;text-align: center;justify-content: center;">
          LineVol
        </div>
      </div>

      <div style="width: 100% !important;height: 160px;display: flex;justify-content: space-around;">
        <div
          style="width: 8%;color: #fff;height: 90px;display: flex;align-items: center;justify-content: center;font-size: 17px;font-weight: 400;">
          通道1
        </div>
        <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;">
          <input style="width: 100%;height: 35px;" type="range" />
        </div>

        <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;">
          <input style="width: 100%;height: 35px;" type="range" />
        </div>

        <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;">
          <input style="width: 100%;height: 35px;" v-model="micVol" max="20" step="5" @input="onMicVolChange"
            type="range" />
        </div>

        <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;">
          <input style="width: 100%;height: 35px;" v-model="lineVol" type="range" :min="-80" :max="0" step="20"
            @input="onTineVolChange" />
        </div>
      </div>

      <div style="width: 100%;height: 160px;display: flex;justify-content: space-around;">
        <div
          style="width:8%;color: #fff;height: 90px;display: flex;align-items: center;justify-content: center;font-size: 17px;font-weight: 400;float: left;">
          通道2
        </div>
        <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;">
          <input style="width: 100%;height: 35px;" type="range" />
        </div>

        <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;">
          <input style="width: 100%;height: 35px;" type="range" />
        </div>

        <div
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;justify-content: center;">
          <div @click="enableSoundAmplification"
            :style="{ backgroundImage: !butOpen1?`url(${require('@/assets/but_open.png')})`:`url(${require('@/assets/but_close.png')})` }"
            style="width: 100px;height: 50px;background-size: 100% 100%;font-size: 12px;font-weight: 400px;color: #fff;display: flex;align-items: center;justify-content: center;cursor: pointer;">
            {{!butOpen1?'开启扩声':'关闭扩声'}}</div>
        </div>

        <div
          style="width: 22%;height: 90px;background-size: 100% 100%;display: flex;align-items: center;justify-content: center;">
          <div @click="enableMute"
            :style="{ backgroundImage: !butOpen2?`url(${require('@/assets/but_open.png')})`:`url(${require('@/assets/but_close.png')})` }"
            style="width: 100px;height: 50px;background-size: 100% 100%;font-size: 12px;font-weight: 400px;color: #fff;display: flex;align-items: center;justify-content: center;cursor: pointer;">
            {{!butOpen2?'开启静音':'关闭静音'}}</div>
        </div>
        <!-- <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 380px;height: 90px;background-size: 100% 100%;display: flex;align-items: center;margin-left: 30px;float: left;">
          <input style="width: 100%;height: 35px;" type="range" />
        </div> -->
      </div>
    </div>



    <!-- <div style="display: flex;flex-direction: column;justify-content: space-between;align-items: center;height: 300px;">
      <div
        style="width: 150px;color: #fff;height: 90px;display: flex;align-items: center;justify-content: center;font-size: 17px;font-weight: 400;float: left;">
        MicVol
      </div>
      <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
        style="width: 380px;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;transform: rotate(-90deg);">
        <input style="width: 100%;height: 35px;" type="range" />
      </div>
    </div> -->

    <!-- <div
      style="display: flex;flex-direction: column;justify-content: space-between;align-items: center;height: 300px;width: 50px;">
      <div
        style="width: 150px;color: #fff;height: 90px;display: flex;align-items: center;justify-content: center;font-size: 17px;font-weight: 400;float: left;">
        MicVol
      </div>
      <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
        style="width: 380px;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;transform: rotate(-90deg);">
        <input style="width: 100%;height: 35px;" type="range" />
      </div>
    </div> -->

    <div style="width: 100%;color: #fff;text-align: center;font-size: 17px;height: 60px;margin-top: 30px;">均衡器</div>
    <div style="width: 100%;display: flex;justify-content: space-around;height: 0%;flex-wrap: wrap;margin-top: 200px;">

      <div v-for="item in 8" :key="item"
        style="display: flex;flex-direction: column;justify-content: space-between;align-items: center;height: 300px;width: 50px">

        <div :style="{ backgroundImage: `url(${require('@/assets/image.png')})` }"
          style="width: 380px;height: 90px;background-size: 100% 100%;display: flex;align-items: center;float: left;transform: rotate(-90deg);">
          <input style="width: 100%;height: 35px;" type="range" />
        </div>
      </div>
    </div>

  </div>
</template>



<script>
  import { ref, getCurrentInstance } from 'vue';
  import { useRouter } from 'vue-router';

  export default {
    setup() {
      const butOpen1 = ref(false);
      const butOpen2 = ref(false);
      const jsonData = ref(null);  // 用来存储导入的 JSON 数据
      const micVol = ref(0);
      const lineVol = ref(0);
      const instance = getCurrentInstance(); // 获取组件实例
      const passwordEntered = ref(false);
      const password = ref('');
      const router = useRouter();
      const checkPassword = () => {
        console.log(password)
        if (password.value == "123456") {
          passwordEntered.value = true; // 正确使用 .value 来修改 ref 的值
        } else {
          alert('密码错误');
        }
      }

      // 激活文件输入框
      const triggerFileInput = () => {
        const fileInput = document.querySelector('input[type="file"]');
        fileInput.click(); // 自动触发文件选择框
      };

      // 处理文件选择事件
      const handleFileChange = (event) => {
        const file = event.target.files[0];  // 获取选择的文件
        if (file && file.type === 'application/json') {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              jsonData.value = JSON.parse(reader.result);  // 解析 JSON 内容
              for (var i = 0; i < jsonData.value.length; i++) {
                send(jsonData.value[i]);
              }
            } catch (error) {
              alert("文件内容不是有效的 JSON 格式");
            }
          };

          reader.readAsText(file);  // 读取文件内容
        } else {
          alert("请选择一个有效的 JSON 文件");
        }
      };

      // 生成并下载 JSON 文件
      const downloadJson = () => {
        // 创建 Blob 对象，表示数据
        var data = []

        if (micVol.value == 0) {
          data[0] = 'relay0 on';
        } else if (micVol.value == 5) {
          data[0] = 'relay1 on';
        } else if (micVol.value == 10) {
          data[0] = 'relay2 on';
        } else if (micVol.value == 15) {
          data[0] = 'relay3 on';
        } else if (micVol.value == 20) {
          data[0] = 'relay4 on';
        }

        if (lineVol.value == 0) {
          data[1] = 'relay5 on';
        } else if (lineVol.value == -20) {
          data[1] = 'relay6 on';
        } else if (lineVol.value == -40) {
          data[1] = 'relay7 on';
        } else if (lineVol.value == -50 || lineVol.value == -60) {
          data[1] = 'relay0 off';
        } else if (lineVol.value == -80) {
          data[1] = 'relay1 off';
        }



        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });

        // 创建 URL 对象指向 Blob 对象
        const url = URL.createObjectURL(blob);

        // 创建一个 <a> 元素
        const a = document.createElement('a');
        a.href = url;
        a.download = 'config.json';  // 设置下载的文件名

        // 模拟点击下载
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 释放 Blob URL
        URL.revokeObjectURL(url);
      };


      const onMicVolChange = () => {
        if (micVol.value == 0) {
          send('relay0 on');
        } else if (micVol.value == 5) {
          send('relay1 on');
        } else if (micVol.value == 10) {
          send('relay2 on');
        } else if (micVol.value == 15) {
          send('relay3 on');
        } else if (micVol.value == 20) {
          send('relay4 on');
        }

      };

      const onTineVolChange = () => {
        if (lineVol.value == 0) {
          send('relay5 on');
        } else if (lineVol.value == -20) {
          send('relay6 on');
        } else if (lineVol.value == -40) {
          send('relay7 on');
        } else if (lineVol.value == -50 || lineVol.value == -60) {
          send('relay0 off');
        } else if (lineVol.value == -80) {
          send('relay1 off');
        }

      };



      const send = (msg) => {
        // 随机生成 0.1 到 0.2 秒的延迟（即 100ms 到 200ms）
        const delay = Math.random() * 0.1 + 0.2;  // 延迟范围 0.1s 到 0.2s

        // 在延迟时间后执行请求
        setTimeout(() => {
          if (instance && instance.proxy) {
            console.log(msg);

            // https://api.iavcms.com/device/aliyunApi/queryDeviceDetail?deviceName=YR_ICC2000_02_37_4D_48_0B_4A&productKey=a1BKFVlkMpx
            // const url = '/send?deviceName=YR_ICC2000_02_37_4D_48_0B_4A&productKey=a1BKFVlkMpx&topicFullName=/a1BKFVlkMpx/YR_ICC2000_02_37_4D_48_0B_4A/user/get&sendMsg=' + msg;

            //    const url = '/send?deviceName=YR_ICC2000_02_37_4D_48_3E_0C&productKey=a1BKFVlkMpx&topicFullName=/a1BKFVlkMpx/YR_ICC2000_02_37_4D_48_3E_0C/user/get&sendMsg=' + msg;
            const url = '/send?deviceName=YR_ICC2000_02_34_36_47_3C_1A&productKey=a1BKFVlkMpx&topicFullName=/a1BKFVlkMpx/YR_ICC2000_02_34_36_47_3C_1A/user/get&sendMsg=' + msg;
            instance.proxy.$http.get(url)
              .then(data => {
                console.log(data);
              })
              .catch(error => {
                console.error("请求错误:", error);
              });
          }
        }, delay * 1000); // 转换为毫秒单位，延迟 100ms 到 200ms
      };

      const enableSoundAmplification = () => {
        butOpen1.value = !butOpen1.value
        if (butOpen1.value) {
          send('relay3 on');
          send('relay6 on');
          micVol.value = 15;
          lineVol.value = -20;
        } else {
          send('relay0 on');
          send('relay5 on');
          micVol.value = 0;
          lineVol.value = 0;
        }
      }

      const enableMute = () => {
        butOpen2.value = !butOpen2.value
        // if (butOpen1.value) {
        //   send('relay3 on');
        //   send('relay6 on');
        //   micVol.value = 15;
        //   lineVol.value = -20;
        // } else {
        //   send('relay0 on');
        //   send('relay5 on');
        //   micVol.value = 0;
        //   lineVol.value = 0;
        // }
      }


      return {
        micVol,
        lineVol,
        passwordEntered,
        jsonData,
        onMicVolChange,
        onTineVolChange,
        downloadJson,
        triggerFileInput,
        handleFileChange,
        password,
        checkPassword,
        router,
        send,
        butOpen1,
        butOpen2,
        enableSoundAmplification,
        enableMute
      };
    },
  };
</script>


<style scoped>
  .container {
    background-image: url('@/assets/bg.png');
    background-size: 100%;
    background-color: rgba(38, 42, 48, 1);
    /* padding: 10px 10px;
    padding: 20px 20px; */
    /* display: flex; */
    flex-wrap: wrap;
    outline: auto;
    height: 400px;
    overflow-x: hidden !important;
    overflow-y: auto;
    /* background-attachment: fixed; */
    background-color: lightgray;
  }

  .but:hover {
    opacity: 0.85;
  }

  input {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: rgba(51, 255, 0, 1);
    /* 默认轨道颜色 */
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    overflow: visible !important;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-repeat: no-repeat !important;
    width: 50px !important;
    height: 50px !important;
    background: url('@/assets/spot.png');
    background-size: 100% 100% !important;
  }

  .slider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #4caf50;
    cursor: pointer;
  }
</style>